import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { CompanyGroupSf6Api } from "../../../shared/nestjs/gd-integrated/services/company-group-sf6.api";
import { EmployeeChecklistSf6Api } from "../../../shared/nestjs/gd-integrated/services/employee-checklist-sf6.api";

@Injectable()
export class ProfileChecklistBloc {

	constructor(
		public personalApi: PersonalNestApi,    
		public globalService: GlobalServiceProvider,
		public nestResponse: NestResponsesProvider,	
		public companyGroupSf6Api: CompanyGroupSf6Api,
		private employeeChecklistSf6Api: EmployeeChecklistSf6Api
	) { }

	type(): Observable<any> {
		return this.employeeChecklistSf6Api.type();
	}

	listing(payload): Observable<any> {
		return this.employeeChecklistSf6Api.listing(payload.empId, payload.type);
	}

	save(data): Observable<any> {
		console.log('BLOC | save', data)    
		return this.employeeChecklistSf6Api.save(data);
	}

	delete(data): Observable<any> {  
		return this.employeeChecklistSf6Api.delete(data);
	}
	
	joinData(payload): Observable<any> {
		return this.employeeChecklistSf6Api.joinData(payload.empId);
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-checklist.bloc.ts